// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminB2cPaymentListItemResponse

import { PaymentStatus, PaymentMethod } from './enums.gen';
import { hydrateAdminBusinessReference, type AdminBusinessReference, type AdminBusinessReferenceApiResponse } from './adminBusinessReference.gen';
import { hydrateAdminPaymentCustomer, type AdminPaymentCustomer, type AdminPaymentCustomerApiResponse } from './adminPaymentCustomer.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type AdminB2cPaymentListItemApiResponse = {
	id: string;
	business: AdminBusinessReferenceApiResponse;
	amount: number;
	fee: number;
	status: PaymentStatus;
	method: PaymentMethod;
	createdAt: string;
	updatedAt: string;
	customer: AdminPaymentCustomerApiResponse | null;
	bookingId: string | null;
};

export type AdminB2cPaymentListItem = {
	id: string;
	business: AdminBusinessReference;
	amount: number;
	fee: number;
	status: PaymentStatus;
	method: PaymentMethod;
	createdAt: DateTime;
	updatedAt: DateTime;
	customer: AdminPaymentCustomer | null;
	bookingId: string | null;
};

export function hydrateAdminB2cPaymentListItem(data: AdminB2cPaymentListItemApiResponse): AdminB2cPaymentListItem {
	return {
		...data,
		business: hydrateAdminBusinessReference(data.business),
		createdAt: DateTimefromISO(data.createdAt)!,
		updatedAt: DateTimefromISO(data.updatedAt)!,
		customer: data.customer ? hydrateAdminPaymentCustomer(data.customer) : null,
	};
}